import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';

export type optionsSliceState = {
  loading: boolean;
  optionsList: Platform[];
};

const initialState: optionsSliceState = {
  loading: false,
  optionsList: []
};

export const optionsSlice = createAppSlice({
  name: 'options',
  initialState,
  reducers: (create) => ({
    getListOptions: create.asyncThunk(
      async ({ code, value }: { code?: string; value?: string }) => {
        const params = `${code ? `CODE=${code}` : `VALUE=${value}`}`;
        const response = await apiFetcher.get(
          `option/get-list-by-type?${params}`
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.optionsList = transformerArray(action.payload);
        },
        rejected: (state) => {
          state.loading = false;
          state.optionsList = [];
        }
      }
    )
  }),
  selectors: {
    watchOptionsList: (platform) => platform.optionsList
  }
});

export const { watchOptionsList } = optionsSlice.selectors;

export const { getListOptions } = optionsSlice.actions;
